// circular-progress.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-progress',
  standalone: false,
  templateUrl: './circle-progress.component.html',
  styleUrls: ['./circle-progress.component.scss']
})
export class CircleProgressComponent {
  @Input() percent: number = 0;
  @Input() radius: number = 100;
  @Input() strokeWidth: number = 10;
  @Input() outerStrokeColor: string = '#18748C';
  @Input() subtitleColor: string = '#3F3F3F';
  @Input() subtitleFontSize: number = 18;
  @Input() subtitle: string = '';
  @Input() titleColor: string = '#262626';
@Input() titleFontSize: number = 30;
  @Input() titleFontWeight: number = 600;
  
  get viewBox(): string {
    return `0 0 ${this.radius * 2} ${this.radius * 2}`;
  }
  
  get textOffset(): number {
    return this.radius / 5;
  }
  get circumference(): number {
  return 2 * Math.PI * (this.radius - this.strokeWidth / 2);
}

calculateDashOffset(percent: number): number {
  return this.circumference - (percent / 100) * this.circumference;
}
}